module.exports = __webpack_public_path__ + "static/media/graphSvg.ee319d2c.svg";